export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center pt-[72px] overflow-hidden bg-background-100"
    >
      <div className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle at 20% 30%, oklch(var(--primary-500)) 1px, transparent 1px), radial-gradient(circle at 80% 70%, oklch(var(--accent-500)) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />

      <div className="relative w-full max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-primary-100/80 text-primary-700 px-4 py-1.5 rounded-full text-sm font-medium mb-6">
              <i className="ri-fire-line text-base"></i>
              <span>实时追踪 · 一手掌握</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight mb-5">
              爆瓜网 — 全网吃瓜爆料第一站
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-heading mb-8">
              明星八卦、网红大瓜、娱乐热点，尽在爆瓜
            </p>

            <div className="text-foreground-700 text-sm md:text-base leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0 space-y-3">
              <p>
                爆瓜网是国内领先的娱乐八卦资讯聚合平台，专注为吃瓜群众提供最新、最快、最全的明星八卦、网红爆料与娱乐热点内容。我们每日追踪全网热搜事件，整合抖音、微博、小红书等多平台爆料信息，让你一个网站看遍所有大瓜。
              </p>
              <p>
                无论是顶流明星恋情实锤、热门综艺争议内幕，还是网红翻车现场、影视圈重磅消息，爆瓜网都在第一时间为你呈现。本站坚持客观整理、多方求证，力求让每条爆料都有据可查。
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-5 md:gap-8 justify-center lg:justify-start mb-8">
              <div className="flex flex-col items-center">
                <span className="text-2xl md:text-3xl font-heading font-bold text-accent-500">15W+</span>
                <span className="text-xs text-foreground-500 mt-1">每日活跃瓜友</span>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block" />
              <div className="flex flex-col items-center">
                <span className="text-2xl md:text-3xl font-heading font-bold text-accent-500">24h</span>
                <span className="text-xs text-foreground-500 mt-1">全天候实时更新</span>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block" />
              <div className="flex flex-col items-center">
                <span className="text-2xl md:text-3xl font-heading font-bold text-accent-500">1000+</span>
                <span className="text-xs text-foreground-500 mt-1">每日新增爆料</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-lg font-medium text-base transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-flashlight-line mr-2"></i>
                立即吃瓜
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto bg-background-50 hover:bg-background-100 text-foreground-800 border border-background-300 px-8 py-3.5 rounded-lg font-medium text-base transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-send-plane-line mr-2"></i>
                投稿爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative aspect-[4/5] md:aspect-[5/4] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20abstract%20collage%20of%20entertainment%20news%20and%20social%20media%20elements%2C%20neon%20magazine%20cutout%20style%20with%20headlines%20and%20trending%20symbols%2C%20warm%20coral%20and%20gold%20accents%20on%20cream%20background%2C%20modern%20editorial%20design%2C%20dynamic%20composition%20with%20overlapping%20shapes%2C%20bold%20typographic%20elements%2C%20pop%20culture%20aesthetic&width=1040&height=1300&seq=hero-baogua-01&orientation=portrait"
                alt="爆瓜网 - 全网吃瓜爆料第一站，明星八卦网红爆料每日最新合集"
                className="w-full h-full object-cover"
                title="爆瓜网 - 全网吃瓜爆料第一站"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/25 via-transparent to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}